export default __webpack_public_path__ + "static/nl-078be4d93a683ae9017c60fefc0513aa.png";